import { render, staticRenderFns } from "./v-btn-wrapper.vue?vue&type=template&id=3acd363e"
import script from "./v-btn-wrapper.vue?vue&type=script&lang=js"
export * from "./v-btn-wrapper.vue?vue&type=script&lang=js"
import style0 from "./v-btn-wrapper.vue?vue&type=style&index=0&id=3acd363e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports